// extracted by mini-css-extract-plugin
module.exports = {"root":"EditVirtualDescriptionPanel_root__tP3-X","form":"EditVirtualDescriptionPanel_form__3l89N","title":"EditVirtualDescriptionPanel_title__1eiak"};